import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Avatar } from "@mui/material";

function createData(avatar, name, date, discipline) {
  return { avatar, name, date, discipline };
}

const rows = [
  createData("https://i.pravatar.cc/10", "Wade Warren", "8-Mar-2023", "RN"),
  createData("https://i.pravatar.cc/10", "Esther Howard", "9-Mar-2023", "LVN"),
  createData(
    "https://i.pravatar.cc/10",
    "Leslie Alexander",
    "9-Mar-2023",
    "PTA"
  ),
  createData(
    "https://i.pravatar.cc/10",
    "Cameron Williamson",
    "9-Mar-2023",
    "PT"
  ),
];

function BirthdaysThisMonth() {
  return (
    <div className="dashboard-table birthdays-table">
      <div className="text-[#98A2B3] bg-white h-[5rem]  text-[14px] font-[700] rounded-t-lg flex items-center pl-4 mt-8  justify-between pr-4">
        Birthdays this month (6)
      </div>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead sx={{ bgcolor: "#FAFAFB", padding: "8px 24px" }}>
            <TableRow>
              <TableCell
                align="left"
                className="dashboardHeadCells"
              ></TableCell>
              <TableCell
                align="left"
                className="!font-bold !text-[#292727] dashboardHeadCells"
              >
                Name
              </TableCell>
              <TableCell
                align="left"
                className="!font-bold !text-[#292727] dashboardHeadCells"
              >
                Date
              </TableCell>
              <TableCell
                align="left"
                className="!font-bold !text-[#292727] dashboardHeadCells"
              >
                Discipline
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow
                key={row.name}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell align="left" className="dashboardTableCell">
                  <Avatar alt="Remy Sharp" src={row.avatar} />
                </TableCell>
                <TableCell align="left" className="dashboardTableCell">
                  {row.name}
                </TableCell>
                <TableCell align="left" className="dashboardTableCell">
                  {row.date}
                </TableCell>
                <TableCell align="left" className="dashboardTableCell">
                  {row.discipline}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default BirthdaysThisMonth;
